import { FormGroup, Validators } from '@angular/forms';

import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';
import { PosValidationAction } from './point-of-sale-validation-action.enum';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { disallowContent, isEmail, requiredWith, requiredWithout, requireLengthBetween } from 'app/validators';

export class PosRules extends FormModel<PosValidationAction> {
    baseValidators: FieldValidatorsMap = {
        amount: [Validators.max(100000)],
        applyAllChecked: [],
        city: [requiredWithout(['isVirtual'])],
        clubName: [],
        countryCode: [requiredWithout(['isVirtual'])],
        description: [],
        discountValue: [],
        email: [Validators.required, isEmail],
        info: [],
        location: [requiredWithout(['isVirtual'])],
        name: [Validators.required],
        code: [
            requiredWithout(['hasRecipient']),
            disallowContent(new RegExp('[^a-zA-Z0-9_-]+'), 'invalid_character'),
            requireLengthBetween(6, 32),
        ],
        phone: [Validators.required],
        posHash: [
            Validators.required,
            disallowContent(new RegExp('[^a-zA-Z0-9_.]+'), 'error.validation.user_hash_allowed_content'),
            disallowContent(new RegExp('^[0-9]+$'), 'error.validation.user_hash_requires_chars'),
        ],
        postCode: [requiredWithout(['isVirtual'])],
        registrationLink: [],
        serviceName: [],
        servicePrice: [],
        usergroup: [requiredWith(['hasRecipient'])],
        isVirtual: [],
        validFrom: [Validators.required],
        value: [Validators.required, Validators.max(100), Validators.min(1)],
        validUntil: [],
    };

    formValidators: FormValidatorsMap = {
        [PosValidationAction.Refund]: {
            clubName: [Validators.required],
            serviceName: [Validators.required],
            servicePrice: [Validators.required],
        },
        [PosValidationAction.DiscountsStore]: {
            amount: [Validators.min(1)],
            discountValue: [Validators.required],
            posId: [Validators.required],
            serviceId: [],
            usergroup: [],
            value: [Validators.required],
        },
    };

    getRefundForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(PosValidationAction.Refund, formFrom);
    }

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(PosValidationAction.Store, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(PosValidationAction.Update, formFrom);
    }

    getUpdateHashForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(PosValidationAction.UpdateHash, formFrom);
    }

    getPosDiscountStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(PosValidationAction.DiscountsStore, formFrom);
    }
}
